<template>
  <ion-button
    id="btn-layer"
    fill="solid"
    color="secondary"
    @click="locateMe()"
  >
    <ion-icon
      slot="icon-only"
      :icon="locate"
    />
  </ion-button>
</template>
<script>
import { locate } from 'ionicons/icons';
import { IonIcon, IonButton } from '@ionic/vue';
import { mapGetters, mapActions } from 'vuex';
import { USER_GETTERS_ENUM, USER_ACTIONS_ENUM } from '../store/modules/user/user.enum';
import { STORE_NAMESPACE } from '../store/modules/store.namespace';

export default {
  components: {
    IonIcon,
    IonButton,
  },
  emits: ['recenterToCurrentLocation'],
  data() {
    return {
      locate,
    };
  },
  computed: {
    ...mapGetters(STORE_NAMESPACE.USER, {
      userCurrentPosition: USER_GETTERS_ENUM.GET_USER_LOCATION,
    }),
  },
  methods: {
    ...mapActions(STORE_NAMESPACE.USER, {
      getUserLocation: USER_ACTIONS_ENUM.GET_USER_LOCATION,
    }),
    locateMe() {
      if (this.userCurrentPosition) {
        this.$emit('recenterToCurrentLocation');
      } else {
        this.getUserLocation().then((data) => {
          if (data) {
            this.$emit('recenterToCurrentLocation');
          }
        });
      }
    },
  },
};
</script>
